<template>
  <div>
    <div id="_div" class="w-100">
      <div id="Titulo_div">
        <h1>Consultar cita</h1>
        <h3 class="h3-text">Consulte su cita e imprima su comprobante de cita.</h3>
      </div>
      <div class="row pt-4" style="aling-items: center; justify-content: center;">
        <div v-if="!mostrarCita" class="col-12 col-sm-12 col-md-12 col-lg-10 col-xlg-8">
            <div class="card-header">
                <h4 >Buscador</h4>                
                </div>
            <div class="card-body">
                
                <hr />
                <div class="row" style="aling-items: center; justify-content: center;">
                    <div id="CURP_div" class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-5 mb-3">
                        <h6 class="input-text-title">CURP *</h6>
                        <input 
                            v-model="peticion_consultarCita.CURP"
                            type="text"
                            id="CURP"
                            name="CURP"
                            :class="[!verificarCURP()  && mostrarErroresInput ? 'form-control border border-danger': 'form-control', 'espacio_base textoMayusculas']"
                            placeholder="CURP"
                            v-mask="'AAAA######AAAAAAN#'"
                        />
                    </div>
                    <div class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-5 mb-3" id="folio_div">
                        <h6 class="input-text-title">Folio de cita*</h6>
                        <input 
                            type="number" 
                            id="folioDeCita" 
                            v-model="peticion_consultarCita.CitaId" 
                            :class="[!verificarValorId(peticion_consultarCita.CitaId)  && mostrarErroresInput ? 'form-control border border-danger': 'form-control', 'espacio_base']"
                            placeholder="Folio de cita"
                        />
                    </div>
                </div>
                <hr />
                <div v-if="verificarValorId(peticion_consultarCita.CitaId) && verificarCURP()" class="clearfix">
                    <div class="float-right ancho_botones">
                        <button type="button" class="btn btn-primary overwrapDeBotones" @click="cargarCita()" style="height:auto"><i class="fas fa-search fa-lg"></i>&nbsp;&nbsp;Buscar</button>
                    </div> 
                </div>
            </div>
        </div>
        <div v-if="mostrarCita && Cita!=undefined && Cita!= null" id="Cita_div" class="col-12 col-sm-12 col-md-12 col-lg-10 col-xlg-9">
          <div class="area">
            <h4>Información de Cita</h4>
            <hr />
            <div class="ml-3"><h6 style="display:inline-block" class="text-secondary">Folio de Cita:</h6><h6 class="pl-3" style="display:inline-block">{{Cita.CitaId}}</h6></div>
            <div class="ml-3"><h6 style="display:inline-block" class="text-secondary">Fecha y hora:</h6><h6 class="pl-3 text-wrap" style="display:inline-block">{{obtenerFechaYHora()}}</h6></div>
            <div class="ml-3"><h6 style="display:inline-block" class="text-secondary">Lugar:</h6><h6 class="pl-3 text-wrap" style="display:inline-block">{{Cita.Area.Area_PJ.Nombre}}</h6></div>
            <div class="ml-3"><h6 style="display:inline-block" class="text-secondary">Estatus de cita:</h6><h6 class="pl-3 text-wrap" style="display:inline-block">{{Cita.TipoEstatusDeCita.Nombre}}</h6></div>
            <div class="ml-3" v-if="Cita.TipoEstatusDeCita.TipoEstatusDeCitaId == 5"><h6 style="display:inline-block" class="text-warning">No olvide revisar su correo electrónico personal para más detalles.</h6></div>
            <div id="tablaDeTramites_div" class="table-responsive col-12">
                <div id="tablaDeTramites_texto_div">
                    <span></span>
                </div>
                <table class="table table-striped table-light table-hover table-bordered table-condensed" id="tablaDeTramites_table" 
                    data-search="false" 
                    data-toggle="tablaDeTramites_table" 
                    data-pagination="false" 
                    data-toolbar="#tablaDeTramites_texto_div"
                    data-page-size="5"
                    data-page-list="[2,5,10]"
                    data-undefined-text="Sin información"
                    data-minimum-count-columns="0">
                    <thead class="table-header-global">
                        <tr>
                          <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:16%" class="text-center align-middle">Folio de Trámite</th>
                          <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:28%" class="text-center align-middle">Trámite</th>
                          <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:28%" class="text-center align-middle">Expedientes</th>
                          <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:28%" class="text-center align-middle">Estatus de Expedientes</th>
                        </tr>
                    </thead>
                    <tbody class="text-dark">
                      <template  v-for="(Tramite) in Cita.TramitesCita">
                        <tr v-for="(Expediente, indexExp) in Tramite.Expedientes" :key="Expediente.ExpedienteId">
                            <td v-if="indexExp === 0" :rowspan="Tramite.Expedientes.length" class="text-center align-middle">{{ Tramite.TramiteCitaId }}</td>
                            <td v-if="indexExp === 0" :rowspan="Tramite.Expedientes.length" class="text-center align-middle">{{ Tramite.TipoTramite.Nombre }}</td>
                            <td class="text-center align-middle">{{ Expediente.TipoDocumento_DBPJ.Nombre }} : {{ Expediente.NumeroDeExpediente }} </td>
                            <td class="text-center align-middle">{{ Expediente.TipoEstatusDeExpediente.Nombre }} </td>
                        </tr>
                      </template>
                    </tbody>
                </table>
            </div>
            <hr />
            <div class="d-flex row">
                <div class="col-12 col-sm-12 col-md-4 col-lg-5 col-xlg-4 pb-2 text-left">
                    <button type="button" class="btn btn-primary overwrapDeBotones" @click="mostrarDivBuscador()"><i class="fas fa-arrow-alt-circle-left fa-lg"></i>&nbsp;&nbsp;Realizar otra búsqueda</button>
                </div>
                <div class="d-sm-none d-md-none d-xlg-block col-lg-1 col-xlg-1"></div>
                <div v-if="sePuedeGenerarComprobante()" class="col-12 col-sm-12 col-md-8 col-lg-7 col-xlg-7 pb-1 text-right">
                    <button type="button" class="btn btn-primary overwrapDeBotones mb-1" @click="generarPDF()"><i class="fas fa-file fa-lg"></i>&nbsp;&nbsp;Generar comprobante de cita</button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import moment from 'moment'
  import store from '@/store/index'
  import LogoPJE from '@/../src/assets/logo-pj-transparente-negro.png'
  
  export default {
    data() {
        return {
            enumeraciones,
            catalogos,
            Cita:null,
            mostrarCita:false,
            mostrarErroresInput: false,
            peticion_consultarCita:
            {
                CURP: '',
                CitaId:0
            }
        }
    },
    methods: {
        /**
         * Función encargada de confirmar que el campo proporcionado contenga algún valor
         * @param {String} estado [valor que representa el campo a verificar]
         */
        campoNoEstaVacio: function(campo) 
        {
            let campoValido = true;
            if(campo == undefined || campo == null || campo == "" || campo.toString().trim() == "") { 
                campoValido = false;
            }
            return campoValido;
        },
        /**
         * Función encargada de que el id tenga un valor
         * @param {int} id [valor que representa el folio de la cita]
         */
        verificarValorId(id)
        {
            return (id != undefined && id != null && id > 0);
        },
        /**
         * Función encargada de verificar que la CURP tenga 18 caracteres y no esté vacia
         */
        verificarCURP:function()
        {
            return (this.campoNoEstaVacio(this.peticion_consultarCita.CURP) && this.peticion_consultarCita.CURP.length == 18)
        },   
        /**
         * Función encargada de verificar que la CURP tenga 18 caracteres y no esté vacia
         */   
        cargarCita: function () 
        {
            comun.SeEstaCargandoInformacion(true);
            this.peticion_consultarCita.EsPrueba = this.enumeraciones.EsPrueba;
            const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false); 

            axios.post(
                api.conexion + api.SICCIJ.sistema.citas.ConsultarCita.VerificarYObtenerCita,
                this.peticion_consultarCita,
                headerPeticion
            ).then(respuesta => {
                comun.SeEstaCargandoInformacion(false);
                if (respuesta.data.SiHayError) {
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    console.log(respuesta);
                } else {
                    this.Cita = respuesta.data.Cita;
                    this.mostrarDivCita();
                }
            })
            .catch(e => {
                console.log("No Hay Respuesta del Servidor" + e);
            });
        },
        /**
         * Función encargada de obtener el formato de fecha y hora
         */ 
        obtenerFechaYHora:function()
        {
            moment.lang('es', 
                {
                months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
                monthsShort: 'Ene._Feb._Mar_Abr._May_Jun_Jul._Ago_Sept._Oct._Nov._Dec.'.split('_'),
                weekdays: 'Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sabado'.split('_'),
                weekdaysShort: 'Dom._Lun._Mar._Mier._Jue._Vier._Sab.'.split('_'),
                weekdaysMin: 'Do_Lu_Ma_Mi_Ju_Vi_Sa'.split('_')
                }
            );
            moment.locale('es');
            let fecha = moment(this.Cita.AgendaBloque.FechaHoraString, "DD/MM/YYYY HH:mm:ss").format("LLLL");
            return fecha + " hrs.";
        },
        /**
         * Función encargada de mostrar el div de citas
         */ 
        mostrarDivCita:function()
        {
            this.mostrarCita = true;
        },
        /**
         * Función encargada de mostrar div del buscador
         */ 
        mostrarDivBuscador:function()
        {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: "Si realizas una nueva búsqueda, todos los datos previamente ingresados serán eliminados.<br />¿Desea continuar?",
                buttons: {
                    cancel: {
                    label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Regresar'
                    },
                    confirm: {
                    label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Continuar'
                    }
                },
                callback: (respuestaRegresarListadoTramites) => {
                    if (respuestaRegresarListadoTramites) 
                    {
                        this.mostrarCita = false;
                        this.Cita = null;
                        this.peticion_consultarCita.CitaId = 0;
                        this.peticion_consultarCita.CURP = '';
                    }
                }
            });
        },
        /**
         * Función encargada de verificar que se puede generar un comprobante de cita.
         */ 
        sePuedeGenerarComprobante:function()
        {
            let puedeGenerarComprobante = true;
            let fecha = moment(this.Cita.AgendaBloque.FechaHoraString, "DD/MM/YYYY HH:mm:ss").fromNow(); 
            if(fecha.includes('hace') || 
               this.Cita.TipoEstatusDeCitaId == 3 || 
               this.Cita.TipoEstatusDeCitaId == 5)//moment(Cita.AgendaBloque.FechaBloque) >= moment() && Cita.TipoEstatusDeCitaId != 3 && Cita.TipoEstatusDeCitaId != 5
            {
                puedeGenerarComprobante = false;
            }
            return puedeGenerarComprobante;
        },
        /**
         * Función encargada de generar PDF
         */ 
        generarPDF: function () 
        {
            var contenidoPDF = "<table>" +
            "<tr><td><h4>Número de Folio: </h4></td><td style='padding-left:1em;'>" + this.Cita.CitaId + "</td></tr>" +
            "<tr><td><h4>Nombre del Solicitante: </h4></td><td style='text-transform: uppercase; padding-left:1em;'>" + this.Cita.InformacionDeSolicitante.Nombres + " " + (this.Cita.InformacionDeSolicitante.PrimerApellido != null? this.Cita.InformacionDeSolicitante.PrimerApellido + " " : "") + (this.Cita.InformacionDeSolicitante.SegundoApellido != null ? this.Cita.InformacionDeSolicitante.SegundoApellido : "") + "</td></tr>" +
            "<tr><td><h4>CURP: </h4></td><td style='text-transform: uppercase; padding-left:1em;'>" + this.Cita.InformacionDeSolicitante.CURP + "</td></tr>" +
            "<tr><td><h4>Fecha y hora de cita: </h4></td><td style='padding-left:1em;'> " + this.Cita.AgendaBloque.FechaHoraString + "</td></tr>" +
            "<tr><td><h4>Lugar: </h4></td><td style='padding-left:1em;'>" + this.Cita.Area.Area_PJ.Nombre + "</td></tr>" +
            "</table>"+
            "<div style='margin-top:1.5em;'><h2 style='display: inline;'>A T E N C I Ó N: </h2><span style='font-style: italic; font-size: 1.5em; display: inline;'>Por parte del Juzgado se le enviará a su <b>correo electrónico</b> la confirmación de su cita, para hacerle saber la disponibilidad de los expedientes o trámites solicitados; si no lo visualiza en la bandeja de entrada, revise su bandeja de 'spam' o 'correo no deseado' un día antes de su cita.</span></div>";
            
            var popupWin = window.open('', '_blank', 'location=no,left=100px');
            try 
            {
                comun.SeEstaCargandoInformacion(false);
                popupWin.document.open(); 
                popupWin.document.write('<html><head><title>Comprobante de Cita</title>');
                popupWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
                popupWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
                popupWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
                popupWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
                popupWin.document.write('</head><body >')
                popupWin.document.write('<img src="' + LogoPJE +'" style="object-fit: cover; width: 10vw; height: 10vw;" alt="Logo de Poder Judicial del Estado de Aguascalientes"/>');
                popupWin.document.write('<h2>Comprobante de Cita </h2>')

                popupWin.document.write(contenidoPDF);
                popupWin.document.write('<hr></body></html>');

                setTimeout(
                    function () { 
                    popupWin.print(); 
                    }, 1000
                );

                popupWin.document.close();
                popupWin.focus(); 
            } 
            catch (e) 
            {
                console.log(e);
                comun.mensajeDeAlerta("Sucedió un error al generar su comprobante, asegúrese de tener habilitadas las <b style='color:yellow;'>ventanas emergentes</b>.", null, null);
            }
        }
    }
  }
</script>

<style scoped>
    .padding-div-low {
        padding-top: 40px;
    }
    .alinear_izq { float: left; }
    .alinear_der { float: right; }
    .contenedor-puntero {
        background: #212529;
        border-radius:2px;
        padding: 10px;
        border:1px solid white;
        margin-bottom: 1.5em;
    }
    .fc-today {
        background: rgba(255,255,255,0.8) !important;
        border: none !important;
        /*border-top: 1px solid #ddd !important;
        font-weight: bold;*/
    } 
    .fc-time-grid .fc-slats td {
        height: 2em !important;
    }
    .fc-content, .fc-time, .fc-title {
        font-size: 1em;
        border-radius: 3px;
        border: 1px solid #ddd;
    }
    .h3-text{
        color: #7e7f74;
    }

    .input-text-title{
        color: black;
    }

    .table-header-global{
      background-color: #004746;
    }


    .card-header {
        background-color: #007573;
        border: 1px solid rgb(44, 44, 44);

    }
    
    .card-body {
        background-color: #bebebc;
        padding: 2em 2em 2em 2em !important;
        border: 1px solid rgb(44, 44, 44);
    }

    .form-control {
        background-color: white;
        color: rgb(63, 62, 62);
        border: 1px solid #656161 !important;        
    }
</style>

<style scoped>
    .padding-div-low {
        padding-top: 40px;
    }
    .textoMayusculas{
        text-transform: uppercase;
    }
    .descripcionColores{
        display: inline-block;
        width: auto;
        text-align: center;
        border-radius: 0.25em;
    }
</style>



// WEBPACK FOOTER //
// src/components/SICCIJ/Citas/ConsultarCita/ConsultaDeCita.vue